export enum Status {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  FLAGGED = 'FLAGGED',
  PENDING = 'PENDING',
}

export enum Actions {
  APPROVE = 'approve',
  REJECT = 'reject',
  FLAG = 'flag',
  EDIT = 'edit',
}

export enum DistributionMethods {
  MINT_LINK = 'MINT_LINK',
  WEBSITE = 'WEBSITE',
  DELIVERY = 'DELIVERY',
  SECRET = 'SECRET',
}

export enum DistributionLabels {
  MINT_LINK = 'Mint Link',
  WEBSITE = 'Website',
  DELIVERY = 'Delivery',
  SECRET = 'Secret',
}

export interface StatusProps {
  name: string
  review: Review | Partial<Review>
  status: Status
  amount: number | null
}

export interface CommentModalProps {
  onCloseClick: () => void
  isOpen: boolean
  review: Review | Partial<Review>
  name: string
}

export interface ListItem {
  id: number
  event_id: number
  status: string
}

export interface Pagination {
  page: number
  limit: number
  total_results: number
  page_count: number
  has_previous_page: boolean
  has_next_page: boolean
}

export interface Review {
  id: string
  reviewer: string
  status: string
  comment: string
  amount: number
  created_at: string
  updated_at: string
}

export interface DropRequest {
  id: string
  reviews: Review[]
  status: Status
  issuer: string
  drop: {
    id: number
    slug: string
    name: string
    email: string
    country: string
    city: string
    description: string
    year: number
    secret_code: number
    drop_url: string
    private_drop: boolean
    virtual_drop: boolean
    image_url: string
    animation_url: string | null
    start_date: string
    end_date: string
    from_admin: boolean
    drop_template: string | null
    fancy_id: string
    created_date: string
    drop_template_id: string | null
  }
  drop_id: number
  issuer_id: string
  distribution_method: DistributionMethods
  amount_requested: number
  created_at: string
  updated_at: string
  amount_approved: number | null
}
